import React from 'react'
import {
  ForstaLogo,
  SurveysLogo,
  PanelManagementLogo,
  DigitalInterviewsLogo,
  DigitalDiariesLogo,
  VideoInsightsLogo
} from 'stylist'

const AppLogo = ({ clientId, ...rest }) => {
  switch (clientId) {
    case 'decipher':
      return <SurveysLogo {...rest} />
    case 'kinesis':
      return <PanelManagementLogo {...rest} />
    case 'intervunow':
      return <DigitalInterviewsLogo {...rest} />
    case 'revelation':
      return <DigitalDiariesLogo {...rest} />
    case 'vi':
      return <VideoInsightsLogo {...rest} />
    case 'intervu2':
      return <DigitalInterviewsLogo {...rest} />
    default:
      return <ForstaLogo {...rest} />
  }
}

export default AppLogo


// WEBPACK FOOTER //
// ./src/components/AppLogo.js